module.exports = __webpack_public_path__ + "img/opencamera.853d052a.png";